// extracted by mini-css-extract-plugin
export var closed = "footerNavigationGroup-module--closed--03b52";
export var groupName = "footerNavigationGroup-module--group-name--cbfc0";
export var groupNameDesktop = "footerNavigationGroup-module--groupNameDesktop--47302";
export var groupNameMobile = "footerNavigationGroup-module--groupNameMobile--3dcd2";
export var navGroup = "footerNavigationGroup-module--nav-group--85cdf";
export var navItems = "footerNavigationGroup-module--nav-items--c09ed";
export var navLink = "footerNavigationGroup-module--nav-link--ea4ff";